import { createContext, useContext, useMemo, useReducer } from "react";
import { debugLogTime } from "../../utils/common";

const ApplicationDataContext = createContext(undefined);

const applicationReducer = (state, action) => {
  debugLogTime("reducer", { state, action }, "ApplicationDataContext");
  switch (action.type) {
    default:
      return state;
  }
};

/**
 *
 * Provides application user related information.
 *
 */
const ApplicationDataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(applicationReducer, {
    loadingState: [],
  });

  const value = useMemo(() => {
    return { state, dispatch };
  }, [state]);

  return <ApplicationDataContext.Provider value={value}>{children}</ApplicationDataContext.Provider>;
};

function useApplicationData() {
  const context = useContext(ApplicationDataContext);
  if (context === undefined) {
    throw new Error("useApplicationData must be used within a ApplicationDataProvider");
  }
  return context;
}

export { ApplicationDataProvider, useApplicationData };
